import React, { useState } from 'react';
import { Col, Container } from 'react-bootstrap';
import DescriptionForm from '../../components/DescriptionForm';

function EmploymentDescription() {

  const [description, setDescription] = useState([]);

  return (
    <Container className="my-4">
      <Col md={8} className="mx-auto">
      <DescriptionForm
        backlink="/employment/form"
        nextlink="/employment/"
        description={description}
        setDescription={setDescription}
      />
      </Col>
    </Container>
  );
}

export default EmploymentDescription;
